import type { RemainingTO, MaintenanceRecord, PilotPercent } from '../types';
import { tapJournal } from '../journal/journalSync';
import { api } from './http';

export const getRemainingTo50h = () => api.get<RemainingTO>('/forms/remaining-to-50h');
export const getRemainingTo100h = () => api.get<RemainingTO>('/forms/remaining-to-100h');
export const getCurrentPeriodStats = () =>
  api.get<{
    period_start_hobbs: number;
    current_hobbs: number;
    total_hours: number;
    pilots: PilotPercent[];
  }>('/forms/current-period-stats');
export const getMaintenanceHistory = (scheduleId?: number) =>
  api.get<MaintenanceRecord[]>('/forms/history', {
    params: scheduleId != null ? { schedule_id: scheduleId } : undefined,
  });
export const performMaintenance50 = (data?: {
  after_flight_id?: number;
  done_date?: string;
  mechanic_name?: string;
}) => tapJournal(api.post('/forms/perform-50', null, { params: data }));
export const performMaintenance100 = (data?: {
  after_flight_id?: number;
  done_date?: string;
  reason: 'initial' | 'hours' | 'year';
  mechanic_name?: string;
}) => tapJournal(api.post('/forms/perform-100', null, { params: data }));
export const setMaintenanceCost = (
  recordId: number,
  cost: number,
  costSplit: 'hours' | 'shares' | 'manual' = 'hours',
  manual?: { payer_ids: number[]; payer_shares: number[] }
) =>
  tapJournal(
    api.put(`/forms/history/${recordId}/cost`, null, {
      params: {
        cost,
        cost_split: costSplit,
        ...(manual && manual.payer_ids.length
          ? {
              payer_ids: manual.payer_ids.join(','),
              payer_shares: manual.payer_shares.join(','),
            }
          : {}),
      },
    })
  );
export const setMaintenanceInfo = (recordId: number, info: string) =>
  tapJournal(api.put(`/forms/history/${recordId}/info`, { info }));
export const updateMaintenance = (
  recordId: number,
  data: {
    after_flight_id?: number;
    done_date?: string;
    mechanic_name?: string;
    reason?: 'initial' | 'hours' | 'year';
  }
) => tapJournal(api.put(`/forms/history/${recordId}`, null, { params: data }));
export const deleteMaintenance = (recordId: number) =>
  tapJournal(api.delete(`/forms/history/${recordId}`));

export type TachInfo = {
  aircraft_id: number;
  tach_current: number;
  tach_offset: number;
  motohours_tip: number;
  replacements: {
    id: number;
    replaced_at: string;
    motohours_at_replace: number;
    old_tach_end: number;
    new_tach_start: number;
    created_by: number | null;
    note: string | null;
  }[];
};

export const getTachInfo = () => api.get<TachInfo>('/forms/tach');
export const replaceTachometer = (data: {
  new_tach_start: number;
  note?: string | null;
}) =>
  tapJournal(
    api.post<TachInfo & { replaced: boolean }>('/forms/tach/replace', data)
  );
